import debug from "src/modules/debug-logger";
import root from "./proto-root";
import decodeProtocolBuffer from "src/modules/protocol-buffers/decodeProtocolBuffer";
// const { Buffer } = window.require("buffer");

export function decodeEnvelope(buffer) {
  return decodeProtocolBuffer({ typePath: "comm.Envelope", buffer, root });
}

export function concatDataParts(parts) {
  return Buffer.concat(parts);
}

export function getEnvelopeContent(envelope) {
  // String : one of message, rpcRequest, rpcResponse
  const type = Object.keys(envelope)[0];
  const payload = envelope[type];
  let content;

  switch (type) {
    case "message": {
      const concreteType = Object.keys(payload)[0];
      const concreteMessage = payload[concreteType];
      content = { type: concreteType, payload: concreteMessage };
      break;
    }
    case "rpcResponse":
    case "rpcRequest": {
      content = {
        type,
        payload
      };
      break;
    }
    default:
      content = {};
      break;
  }
  if (payload.audioPacket) {
    debug.audioProcessing(`Received ${content.type}`, content.payload);
  } else if (payload.pingRequest || payload.pingResponse) {
    debug.pingPong(`Received ${content.type}`, content.payload);
  } else {
    debug.messenger(`Received ${content.type}`, content.payload);
  }
  return content;
}
